import { getInterface } from '@/utils/js/initVariable';
const prefixUrl = 'api/UserDrawApi/';
export const queryFavorites = (data)=>{
  return getInterface.post(`${prefixUrl}queryFavorites`, data);
}
export const queryFavoriteDetail = (data)=>{
  return getInterface.post(`${prefixUrl}queryFavoriteDetail/${data}`, data);
}
export const queryGraphicList = (data)=>{
  return getInterface.post(`${prefixUrl}queryGraphicList/${data}`, data);
}
export const putGraphic = (data)=>{
  return getInterface.post(`${prefixUrl}putGraphic`, data);
}
export const putFavorite = (data)=>{
  return getInterface.post(`${prefixUrl}putFavorite`, data);
}
export const delFavorite = (data)=>{
  return getInterface.post(`${prefixUrl}delFavorite/${data}`, data);
}